import React, { useState } from "react";
import { StarRow } from "@/components/Stars";
import { api } from "@/lib/api";
import { useLang } from "@/i18n";
import { toast } from "sonner";
import { Languages, Loader2 } from "lucide-react";

export const ReviewCard = ({ r, className = "" }) => {
  const { t } = useLang();
  const [showT, setShowT] = useState(false);
  const [translation, setTranslation] = useState(r.translated_text || null);
  const [loading, setLoading] = useState(false);

  const toggle = async () => {
    if (showT) { setShowT(false); return; }
    if (translation) { setShowT(true); return; }
    setLoading(true);
    try {
      const { data } = await api.post(`/reviews/${r.id}/translate`);
      setTranslation(data.text);
      setShowT(true);
    } catch {
      toast.error(t.reviewsPage.translate_error);
    } finally {
      setLoading(false);
    }
  };

  const displayText = showT && translation ? translation : r.text;

  return (
    <div className={`bg-surface border border-line p-8 flex flex-col ${className}`} data-testid="review-card">
      <StarRow value={r.rating} />
      <p className="mt-4 text-ink/80 leading-relaxed italic flex-1">"{displayText}"</p>
      <button
        onClick={toggle}
        disabled={loading}
        data-testid="translate-btn"
        className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-terracotta hover:text-terracotta-hover transition-colors self-start disabled:opacity-60"
      >
        {loading ? <Loader2 size={14} className="animate-spin" /> : <Languages size={14} />}
        {showT ? t.reviewsPage.show_original : t.reviewsPage.translate}
      </button>
      <div className="mt-4 font-semibold text-forest">— {r.name}</div>
      {(r.student_class || r.age) && (
        <div className="mt-1 text-xs text-ink/50 tracking-wide">{[r.student_class, r.age].filter(Boolean).join(" · ")}</div>
      )}
    </div>
  );
};
